import { DatePickerInputItem } from 'client/ui/form/input/DatePickerInputItem';
import { SelectInputItem } from 'client/ui/form/input/SelectInputItem';
import { TextInputItem } from 'client/ui/form/input/TextInputItem';
import { FormDividerSpace } from 'client/ui/space/FormDividerSpace';
import { useExtraEuCountryCode } from 'common/schema/country-codes/useExtraEuCountryCode';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { HomeCountrySelectItem } from './HomeCountrySelectItem';

export interface IUserProfileFieldsFormProps {}

/**
 * Campi del profilo del cittadino comuni sia alla registrazione che
 * alla modifica del profilo.
 */
export function UserProfileFieldsForm(props: IUserProfileFieldsFormProps) {
  const { t } = useTranslation();
  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 12 }
  };

  return (
    <>
      <FormDividerSpace
        title={t('user.registration.form.divider-title', 'Dati anagrafici')}
        layout={layout}
        style={{ marginTop: 0 }}
      />

      <TextInputItem
        name="name"
        label={t('user.registration.form.name', 'Nome')}
      />
      <TextInputItem
        name="familyName"
        label={t('user.registration.form.family-name', 'Cognome')}
      />
      <TextInputItem
        name="fiscalNumber"
        label={t('user.registration.form.fiscal-number', 'Codice Fiscale')}
      />
      <TextInputItem
        name="mobilePhone"
        label={t('user.registration.form.mobile-phone', 'Telefono Cellulare')}
      />
      {/* <TextInputItem
                      name="address"
                      label={t('user.registration.form.address', 'Indirizzo')}
                    /> */}
      <DatePickerInputItem
        name="dateOfBirth"
        label={t('user.registration.form.date-of-birth', 'Data di Nascita')}
        type="from"
        style={{ width: '100%' }}
      />
      <TextInputItem
        name="placeOfBirth"
        label={t('user.registration.form.place-of-birth', 'Luogo di Nascita')}
      />
      <TextInputItem
        name="countyOfBirth"
        label={t(
          'user.registration.form.county-of-birth',
          'Provincia di Nascita'
        )}
      />
      <HomeCountrySelectItem name="country" />
    </>
  );
}
